'use client';

import { signOut } from 'supertokens-auth-react/recipe/session';
import { useCallback } from 'react';

import logoutImg from '../../../public/images/partnerhub/logout.png';
import { useRouter } from 'next/navigation';
import { frontendConfig } from '@/config/frontendConfig';
import CustomImage from '@/components/CustomImage/CustomImage';

const PartnerhubLogoutForm = () => {
    const router = useRouter();
    const logout = useCallback(async () => {
        await signOut();
        router.push(`${frontendConfig().appInfo.websiteBasePath as string}`);
    }, []);

    return (
        <button type="submit" className="tw-cursor-pointer" onClick={logout}>
            <CustomImage height="23" src={logoutImg} alt="Logout" />
            <span className="d-block d-lg-none">Logout</span>
        </button>
    );
};

export default PartnerhubLogoutForm;
